export interface EpisodeItem {
  no: number;
  title: string;
  duration: string;
  synopsis: string;
  airDate: string;
}

const episodeTitles = [
  "出发的那一天",
  "旧约定的回声",
  "第一次交手",
  "晴空下的秘密",
  "迷路也要往前走",
  "深夜的同伴",
  "被藏起的那页",
  "反方向的鼓点",
  "雨停之前",
  "全部的答案在风里",
  "重新站起来",
  "尾声之前",
];

const episodeBlurbs = [
  "故事从一次意外的相遇开始。主角在毫无准备的状态下被推入全新的局面，必须做出第一个选择，而这个选择将决定后续的全部走向。",
  "一封旧信带来了意料之外的线索。两个人沿着记忆中的路线重新走了一遍，才发现当年被忽略的细节，其实早就是答案。",
  "第一次真正的对决。对手比想象中更强，主角在被逼到极限的瞬间，第一次意识到自己真正想要守护的是什么。",
  "难得的休息日，却因为一个小意外变成全员的远足。轻松的日常里埋下了关键伏笔，也让队伍之间的信任加深了一层。",
  "计划失败，方向全错，队伍在陌生街区迷路。有人开始抱怨，有人却把这次迷路当成新的机会，气氛在夜里悄然变化。",
  "新同伴的加入带来了新的矛盾。过去的经历让彼此都保持着距离，直到一次不期而至的危机把大家真正绑在一起。",
  "旧档案的最后一页被撕掉了。为了找回缺失的内容，主角不得不面对一个一直回避的人，以及一段不愿提起的过去。",
  "对抗节奏被彻底打乱。原本的战术失效，只能临场重组。最不被看好的那一位，站到了最关键的位置上。",
  "雨下了整整一天。所有的矛盾都在这天爆发，所有的和解也发生在这天。雨停时，大家的答案已经不一样了。",
  "真相终于被摊开在阳光下。有人在笑，有人在哭，而主角第一次清楚地说出了自己的目标。",
  "失败后的沉默比争吵更难熬。主角一个人重新走了一遍最初的路，在旧地方找回了初心，然后带着新的队伍回到起点。",
  "终章之前的短暂休整。每个人都写下了一封信，留给未来的自己，也留给了屏幕前的观众。",
];

export const buildEpisodes = (total: number): EpisodeItem[] => {
  const count = Math.min(total, 24);
  return Array.from({ length: count }, (_, index) => ({
    no: index + 1,
    title: episodeTitles[index % episodeTitles.length],
    duration: "24 分钟",
    synopsis: episodeBlurbs[index % episodeBlurbs.length],
    airDate: `2026-${String(((index + 3) % 12) + 1).padStart(2, "0")}-${String(((index * 3) % 27) + 1).padStart(2, "0")}`,
  }));
};